import React from 'react';
import PropTypes from 'prop-types';
import colors from 'customizations/js/color-variables';

export const IconAll = ({ className }) => (
  <svg className={className} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip-icon-all)">
      <path className="icon-filled-path" fillRule="evenodd" clipRule="evenodd" d="M13.4411 0.48568C13.793 0.309725 14.2072 0.309725 14.5591 0.48568L26.9553 6.68379C27.3788 6.89553 27.6463 7.32836 27.6463 7.80183C27.6463 8.27529 27.3788 8.70812 26.9553 8.91986L14.5591 15.118C14.2072 15.2939 13.793 15.2939 13.4411 15.118L1.04483 8.91986C0.621353 8.70812 0.35385 8.27529 0.35385 7.80183C0.35385 7.32836 0.621353 6.89553 1.04483 6.68379L13.4411 0.48568ZM4.39894 7.80183L14.0001 12.6024L23.6012 7.80183L14.0001 3.00126L4.39894 7.80183Z" fill={colors.gray20} />
      <path className="icon-filled-path" d="M0.485817 19.6391C0.794553 19.0216 1.54539 18.7713 2.16287 19.0801L14.0001 24.9987L25.8373 19.0801C26.4548 18.7713 27.2056 19.0216 27.5143 19.6391C27.8231 20.2566 27.5728 21.0074 26.9553 21.3161L14.5591 27.5143C14.2072 27.6902 13.793 27.6902 13.4411 27.5143L1.04483 21.3161C0.42736 21.0074 0.17708 20.2566 0.485817 19.6391Z" fill={colors.gray20} />
      <path className="icon-filled-path" d="M2.16287 12.8819C1.54539 12.5732 0.794553 12.8235 0.485816 13.441C0.17708 14.0584 0.42736 14.8093 1.04483 15.118L13.4411 21.3161C13.793 21.4921 14.2072 21.4921 14.5591 21.3161L26.9553 15.118C27.5728 14.8093 27.8231 14.0584 27.5143 13.441C27.2056 12.8235 26.4548 12.5732 25.8373 12.8819L14.0001 18.8006L2.16287 12.8819Z" fill={colors.gray20} />
    </g>
  </svg>
);

IconAll.propTypes = {
  className: PropTypes.string,
};

IconAll.defaultProps = {
  className: '',
};
